
<script>
import config from "../../config";
import pagination from "laravel-vue-pagination";
import PageHeader from "../../components/page-header";
import { bannerService } from "../../services";
import { error_message,debounce } from "../../Helper/helper";
import BannerListTable from "./banner-list-table";

export default {
  components: { pagination, bannerService, PageHeader, BannerListTable },
  data() {
    const { status,orderBy,sortBy} = this.$route.query;
    return {
      sortBy:sortBy || "sort",
      sortDesc: orderBy && orderBy != '' ? true : orderBy,
      banners: [],
      paginations: {},
      bannerCount: '',
      limit: 1,
      search: "",
      status: status == undefined ? 1 :status,
      config: config,
      loading: true,
      searchData:debounce(()=>{
        if(!this.init){
          const {status,orderBy,sortBy} = this.$data;
          this.$router.replace({name: 'banner-list', query: {status,orderBy,sortBy}})
        }
        this.getBanner();
        this.init = false;
      },500),
      
      fields: [
        { key: "image", label: "#", sortable: false },
        { key: "name", label: this.trans.get("__JSON__.Name"), sortable: true },
		{ key: "banner_type", label: "Type", sortable: false},
        { key: "restaurants", label: "Vendor Name", sortable: false},
        // { key: "sort", label: "Sort", sortable: true},
        {
          key: "status",
          label: this.trans.get("__JSON__.Status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
        },
      ],
	  dine_in: [],
	  delivery_takeaway: [],
	  dine_in_pagination: {},
	  delivery_takeaway_pagination: {},
	  din_in_count: 0,
	  delivery_takeaway_count: 0,
    };
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    getBanner(page) {
      this.loading = true;
      var filters = {
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
      }
      bannerService
        .getBanner(filters)
        .then((response) => {
			this.loading = false;
			this.response = response.data.result;

			this.dine_in_pagination = response.data.result.dine_in.data;
			this.delivery_takeaway_pagination = response.data.result.delivery_takeaway.data;

			this.dine_in = response.data.result.dine_in.data.data;
			this.delivery_takeaway = response.data.result.delivery_takeaway.data.data;

			this.din_in_count = response.data.result.dine_in.bannerCount;
			this.delivery_takeaway_count = response.data.result.delivery_takeaway.bannerCount;
        });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getBanner();
    },
    // deleteById(id) {
    //   if (confirm("Are you sure you want to delete?")) {
    //     bannerService.deletebanner({ id: id }).then((response) => {
    //       error_message(response.data.message);
    //       this.getBanner();
    //     });
    //   }
    // },
  },
};
</script>

<template>
  <div>
    <div class="row">
          <div class="col-12">
              <div
              class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
              >
              <div class="page-title-left">
                  <div class="avatar-xs mr-3">
                  <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                      <i class="bx bx-purchase-tag"></i>
                  </span>
                  </div>
                  <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Banners') }}
					<!-- ({{bannerCount}}) -->
				</h4>
              </div>
              <div class="page-title-right">
                  <router-link v-if="$auth.hasPermission(config.permissions.banner_write)" :to="{name: 'banner-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                  <i class="mdi mdi-plus mr-1"></i> {{ trans.get('__JSON__.Add Banner') }}
                  </router-link>
                  <router-link v-if="$auth.hasPermission(config.permissions.banner_write)" :to="{name: 'banner-add'}" class="btn btn-success btn-rounded mr-2 m-add-btn">
                  <i class="mdi mdi-plus"></i>
                  </router-link>
              </div>
              </div>
          </div>
      </div>
    <!-- end row -->
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-8">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Status') }} :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value="">{{ trans.get('__JSON__.All') }}</option>
                      <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                      <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>{{ trans.get('__JSON__.Search') }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="trans.get('__JSON__.Search Placeholder')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

			  	<div class="col-md-12">
					<b-tabs
						justified
						nav-class="nav-tabs-custom mt-0 order-tabs"
						content-class="p-3 text-muted"
						lazy
						>
							<b-tab >
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-plus"></i>
									</span>
									<span class="d-none d-sm-inline-block">{{ trans.get("__JSON__.Dine In") }}</span>
									<span v-if="din_in_count && din_in_count !== '0'" class="badge badge-success font-size-12">
										{{ din_in_count && din_in_count || 0 }}
									</span>
								</template>

								<banner-list-table :fields="fields" :banners="dine_in" :paginations="dine_in_pagination" :sortBy="sortBy" :loading="loading" @callBanner="getBanner" @sortingChanged="sortingChanged"/>
								
							</b-tab>

							<b-tab >
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-plus"></i>
									</span>
									<span class="d-none d-sm-inline-block">{{ trans.get("__JSON__.Delivery - Takeaway") }}</span>

									<span v-if="delivery_takeaway_count && delivery_takeaway_count !== '0'" class="badge badge-success font-size-12">
										{{ delivery_takeaway_count && delivery_takeaway_count || 0 }}
									</span>
								</template>
								
								<banner-list-table :fields="fields" :banners="delivery_takeaway" :paginations="delivery_takeaway_pagination" :sortBy="sortBy" :loading="loading" @callBanner="getBanner" @sortingChanged="sortingChanged" />
							</b-tab>
					</b-tabs>
				</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<style>
.banner-table .table thead th:nth-child(1),.banner-table .table thead th:nth-child(3),.banner-table .table thead th:nth-child(5){
  pointer-events: none;
}
</style>